import type { WorkflowVersionSummary } from '@erp/rpc';
import { T } from 'gt-react';
import { SealCheckIcon } from '@phosphor-icons/react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export function VersionStatusBadge({
  status,
  isPinned,
  compact = false,
}: Pick<WorkflowVersionSummary, 'status' | 'isPinned'> & {
  compact?: boolean;
}) {
  const className = cn(compact && 'h-4 px-1 text-[10px] font-normal');
  if (status === 'draft')
    return (
      <Badge variant="secondary" className={className}>
        <T context="workflow version status">Draft</T>
      </Badge>
    );
  if (isPinned)
    return (
      <Badge className={className}>
        <SealCheckIcon className="mr-1 h-3 w-3" weight="fill" />
        <T context="workflow version status">Published</T>
      </Badge>
    );
  return (
    <Badge variant="outline" className={className}>
      <T context="workflow version status">Finalized</T>
    </Badge>
  );
}
